import React from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  CircularProgress,
  Typography
} from "@material-ui/core";
import PropTypes from "prop-types";
import UploadStatusIcon from "./UploadStatusIcon";
import { plural } from "./UploadCommon";

const SaveToDBStep = props => {
  let statusMessage;
  if (props.someFilesAreUploading) statusMessage = "Uploading...";
  else if (props.allFilesUploaded) {
    statusMessage = "All files have uploaded.";
  } else
    statusMessage = `You are about to save the following ${plural(
      props.filesNotYetUploaded.length,
      "file"
    )} to the
database.`;

  return (
    <div>
      <Typography>
        <b>{statusMessage}</b>
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Filename</TableCell>
            <TableCell>Submission ID</TableCell>
            <TableCell style={{ width: "100px" }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.files.map(file => (
            <TableRow>
              <TableCell>{file.name}</TableCell>
              <TableCell>
                {file.isUploading && <CircularProgress />}
                {file.hasUploaded && file.submissionID}
              </TableCell>
              <TableCell style={{ width: "100px" }}>
                <UploadStatusIcon file={file} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
SaveToDBStep.propTypes = {
  someFilesAreUploading: PropTypes.bool.isRequired,
  allFilesUploaded: PropTypes.bool.isRequired,
  filesNotYetUploaded: PropTypes.arrayOf(PropTypes.object).isRequired,
  files: PropTypes.arrayOf(PropTypes.object).isRequired
};
export default SaveToDBStep;
